import React, { useState } from "react";
import {
    Box,
    Flex,
    Text,
    Button,
    Badge,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    IconButton,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    useDisclosure,
    VStack,
    HStack,
    SimpleGrid,
} from "@chakra-ui/react";
import { FiEdit, FiMoreVertical, FiFilter, FiPlus } from "react-icons/fi";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";
import GameModal from "./GameModal";
import FilterDrawer from "./FilterDrawer";

const PAGE_SIZE = 5;

const initialData = [
    {
        league: "MMA",
        title: "Rose Namajunas vs Natalia Silva",
        category: "Mixed Martial Arts",
        gameStart: "2026-01-25T03:00",
        betStart: "2025-12-16T19:16",
        slug: "rose-namajunas-vs-natalia-silva",
    },
    {
        league: "MMA",
        title: "Wiktor Zalewski vs Romain Debienne",
        category: "Mixed Martial Arts",
        gameStart: "2025-12-20T16:00",
        betStart: "2025-12-16T19:16",
        slug: "wiktor-zalewski-vs-romain-debienne",
    },
    {
        league: "Ligue 2 – France",
        title: "Montpellier vs USL Dunkerque",
        category: "Soccer",
        gameStart: "2026-01-05T19:45",
        betStart: "2025-12-16T19:16",
        slug: "montpellier-vs-usl-dunkerque",
    },
];

export default function CancelledGames() {
    const [data, setData] = useState(initialData);
    const [page, setPage] = useState(1);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
        isOpen: isFilterOpen,
        onOpen: onFilterOpen,
        onClose: onFilterClose
    } = useDisclosure();
    const [editData, setEditData] = useState(null);

    const totalPages = Math.ceil(data.length / PAGE_SIZE);
    const paginated = data.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
    const SIDEBAR_WIDTH = "240px";

    const handleAddNew = () => {
        setEditData(null);
        onOpen();
    };

    const handleEdit = (game) => {
        setEditData(game);
        onOpen();
    };

    const handleFilter = (filters) => {
        console.log("Applying filters:", filters);
    };

    const handleSave = (formData) => {
        if (editData) {
            setData((prev) =>
                prev.map((g) => (g.slug === editData.slug ? { ...g, ...formData, gameStart: formData.gameStartsFrom, betStart: formData.betStartsFrom, category: formData.eventType } : g))
            );
        } else {
            setData((prev) => [
                ...prev,
                {
                    league: formData.league,
                    title: formData.title,
                    category: formData.eventType,
                    gameStart: formData.gameStartsFrom,
                    betStart: formData.betStartsFrom,
                    slug: formData.slug,
                },
            ]);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return date.toLocaleString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    }

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={6}
                bg="gray.50"
                minH="100vh"
                mt="80px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                {/* Header */}
                <Flex justify="space-between" mb={6} align={{ base: "stretch", md: "center" }} direction={{ base: "column", md: "row" }} gap={4}>
                    <Text fontSize="2xl" fontWeight="bold">
                        Cancelled Games
                    </Text>
                    <Flex gap={3}>
                        <Button leftIcon={<FiFilter />} variant="outline" onClick={onFilterOpen}>
                            Filter
                        </Button>
                        <Button leftIcon={<FiPlus />} colorScheme="blue" onClick={handleAddNew}>
                            Add New Game
                        </Button>
                    </Flex>
                </Flex>

                {/* Table */}
                <Box bg="white" borderRadius="md" overflow="hidden" display={{ base: "none", md: "block" }}>
                    <Table>
                        <Thead bg="#4f46e5">
                            <Tr>
                                <Th color="white">League | Title</Th>
                                <Th color="white">Category</Th>
                                <Th color="white">Game Starts</Th>
                                <Th color="white">Bet Starts</Th>
                                <Th color="white">Status</Th>
                                <Th color="white">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {paginated.map((g, i) => (
                                <Tr key={i}>
                                    <Td>
                                        <Text fontWeight="bold">{g.league}</Text>
                                        <Text fontSize="sm" color="gray.500">
                                            {g.title}
                                        </Text>
                                    </Td>
                                    <Td>{g.category}</Td>
                                    <Td>{formatDate(g.gameStart)}</Td>
                                    <Td>{formatDate(g.betStart)}</Td>
                                    <Td>
                                        <Badge colorScheme="red" variant="outline">
                                            Cancelled
                                        </Badge>
                                    </Td>
                                    <Td>
                                        <Flex gap={2}>
                                            <IconButton
                                                icon={<FiEdit />}
                                                variant="outline"
                                                size="sm"
                                                onClick={() => handleEdit(g)}
                                            />
                                            <Menu>
                                                <MenuButton
                                                    as={IconButton}
                                                    icon={<FiMoreVertical />}
                                                    size="sm"
                                                    variant="outline"
                                                />
                                                <MenuList>
                                                    <MenuItem>View</MenuItem>
                                                    <MenuItem>Close Betting</MenuItem>
                                                </MenuList>
                                            </Menu>
                                        </Flex>
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </Box>

                {/* Mobile View */}
                <VStack display={{ base: "flex", md: "none" }} spacing={4} align="stretch">
                    {paginated.map((g, i) => (
                        <Box key={i} bg="white" p={4} borderRadius="lg" boxShadow="sm" border="1px solid" borderColor="gray.100">
                            <Flex justify="space-between" align="start" mb={2}>
                                <VStack align="start" spacing={0}>
                                    <Text fontWeight="bold" fontSize="md">{g.league}</Text>
                                    <Text fontSize="sm" color="gray.500">{g.title}</Text>
                                    <Badge colorScheme="blue" variant="outline" mt={1} fontSize="xs">
                                        {g.category}
                                    </Badge>
                                </VStack>
                                <Menu>
                                    <MenuButton as={IconButton} icon={<FiMoreVertical />} size="sm" variant="ghost" />
                                    <MenuList>
                                        <MenuItem onClick={() => handleEdit(g)}>Edit</MenuItem>
                                        <MenuItem>View</MenuItem>
                                        <MenuItem>Close Betting</MenuItem>
                                    </MenuList>
                                </Menu>
                            </Flex>

                            <SimpleGrid columns={2} spacing={3} mt={4}>
                                <Box>
                                    <Text fontSize="xs" color="gray.500">Game Starts</Text>
                                    <Text fontSize="sm" fontWeight="500">{formatDate(g.gameStart)}</Text>
                                </Box>
                                <Box>
                                    <Text fontSize="xs" color="gray.500">Bet Starts</Text>
                                    <Text fontSize="sm" fontWeight="500">{formatDate(g.betStart)}</Text>
                                </Box>
                            </SimpleGrid>

                            <Flex justify="space-between" align="center" mt={4} pt={3} borderTop="1px solid" borderColor="gray.100">
                                <Badge colorScheme="red" variant="subtle" px={2} py={1} borderRadius="full">
                                    Cancelled
                                </Badge>
                                <Button size="sm" leftIcon={<FiEdit />} variant="outline" onClick={() => handleEdit(g)}>
                                    Edit
                                </Button>
                            </Flex>
                        </Box>
                    ))}
                </VStack>

                {/* Pagination */}
                <Flex justify="flex-end" mt={4} gap={2}>
                    <Button
                        size="sm"
                        onClick={() => setPage((p) => p - 1)}
                        isDisabled={page === 1}
                    >
                        Prev
                    </Button>
                    {[...Array(totalPages)].map((_, i) => (
                        <Button
                            key={i}
                            size="sm"
                            colorScheme={page === i + 1 ? "blue" : "gray"}
                            onClick={() => setPage(i + 1)}
                        >
                            {i + 1}
                        </Button>
                    ))}
                    <Button
                        size="sm"
                        onClick={() => setPage((p) => p + 1)}
                        isDisabled={page === totalPages}
                    >
                        Next
                    </Button>
                </Flex>
            </Box>

            <GameModal
                isOpen={isOpen}
                onClose={onClose}
                editData={editData}
                onSave={handleSave}
            />
            <FilterDrawer
                isOpen={isFilterOpen}
                onClose={onFilterClose}
                onFilter={handleFilter}
            />
        </>
    );
}
